$(document).ready(function() {
	if ($('.js-preorder-content').length > 0) {
		$(document).on('scroll', function() {
		    if ($(window).width() <= 520 && $('.js-select-bottom').hasClass('show') && 
		    	($(this).scrollTop() >= $('.b-pre-order-main__right').find('.js-preorder-content-core').find('.b-pre-order-main__edition-wrap').position().top || 
		    		$(this).scrollTop() >= $('.b-pre-order-main__right').find('.js-preorder-content-commander').find('.b-pre-order-main__edition-wrap').position().top || 
		    		$(this).scrollTop() >= $('.b-pre-order-main__right').find('.js-preorder-content-mythic').find('.b-pre-order-main__edition-wrap').position().top) && 
		    		($(this).scrollTop() + $(window).height()) <= $('#about').position().top) {
		    	$('.b-pre-order-main__right').find('.js-preorder-content-core').addClass('button-fixed');
		    	$('.b-pre-order-main__right').find('.js-preorder-content-commander').addClass('button-fixed');
		    	$('.b-pre-order-main__right').find('.js-preorder-content-mythic').addClass('button-fixed');
		    	$('.js-select-bottom').addClass('fixed');
		    } else {
		    	$('.b-pre-order-main__right').find('.js-preorder-content-core').removeClass('button-fixed');
		    	$('.b-pre-order-main__right').find('.js-preorder-content-commander').removeClass('button-fixed');
		    	$('.b-pre-order-main__right').find('.js-preorder-content-mythic').removeClass('button-fixed');
		    	$('.js-select-bottom').removeClass('fixed');
		    }
		});
	}
});



// WEBPACK FOOTER //
// ./src/js/pages/main/content-button.js